import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {CityArea} from "../../../../../../models/countries/country";
import {branchesService} from "../../../../../../services/branches/branches.service";

export interface WidgetProps
{
    cityId?: number;
    value?: any;
    onChange?: (value: any) => void;
}
export const UiInputWidgetCityArea: React.FC<WidgetProps> = ({cityId, value, onChange}) => {

    const [disabled, setDisabled] = useState<boolean>(false);
    const [noValues, setNoValues] = useState<boolean>(false);
    const [values, setValues] = useState<CityArea[]>([]);

    useEffect(() => {
        setDisabled(true);
        if (cityId) {
            try {
                branchesService.getCityAreas(cityId).then(values => {
                    setValues(values);
                    setNoValues(values.length === 0)
                });
            } finally {
                setDisabled(false);
            }
        }
    }, [cityId])

    if (noValues) {
        return null;
    }

    return (
        <Select
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
            disabled={disabled}
        >
            {values.map(value => (
                <Select.Option value={value.id}>{value.name}</Select.Option>
            ))}
        </Select>
    )
}